package presentation.screens.main

import features.videoDetails.data.model.FavoriteEntity
import features.watch.model.WatchEntry
import features.watch.model.WatchTarget
import models.Genre
import models.User
import models.VideoDetails
import presentation.screens.allVideos.AllVideosState
import utils.UiAction
import utils.UiState

data class MainState(
    val isLoading: Boolean = true,
    val isNextLoading: Boolean = true,
    val isError: Boolean = false,
    val error: String? = null,
    val drawerState: DrawerStateValue = DrawerStateValue.CLOSED,
    val menuItems: List<MenuItem> = MenuItem.entries,
    val selectedMenu: MenuItem = MenuItem.KINOSHKA,
    val genres: List<Genre> = emptyList(),
    val soonMovies: List<VideoDetails>? = null,
    val newMovies: List<VideoDetails>? = null,
    val newTvShows: List<VideoDetails>? = null,
    val isMainError: Boolean = false,
    val cartoonsVideos: List<VideoDetails>? = null,
    val cartoonsTvVideos: List<VideoDetails>? = null,
    val isCartoonError: Boolean = false,
    val favoriteList: List<FavoriteEntity>? = null,
    val continueWatching: List<WatchEntry> = emptyList(),
    val continueWatchingReady: Boolean = false,
    val watchVideo: Boolean = false,
    val isFavoriteSync: Boolean = false,
    val isFavoriteError: Boolean = false,
    val updateAvailable: Boolean = false,
    val tasteEnabled: Boolean = true,
    val user: User? = null,
    /** TV: restore focus to this video after returning from details. */
    val lastFocusedVideoId: Int? = null,
) : UiState {

    enum class DrawerStateValue {
        OPEN, OPENED, CLOSED
    }

    enum class MenuItem(
        val title: String,
        val icon: String,
    ) {
        KINOSHKA(
            title = "appName",
            icon = "kinoshka.xml",
        ),
        FILMS(
            title = "films",
            icon = "film.xml",
        ),
        TVSHOWS(
            title = "tv_shows",
            icon = "tv_show.xml",
        ),
        CARTOONS(
            title = "cartoons",
            icon = "cartoon.xml",
        ),
        FAVORITES(
            title = "favorites",
            icon = "fill_favorite.xml",
        ),
    }
}

sealed interface MainMVIAction : UiAction {

    data object FavoriteOpened : MainMVIAction
    data object Reload : MainMVIAction
    data object ClickBackWithDrawer : MainMVIAction
    data object OnDrawerOpened : MainMVIAction
    data object OnMenuClicked : MainMVIAction
    data object FetchNextPage : MainMVIAction
    data class OnMenuItemClicked(val menuItem: MainState.MenuItem) : MainMVIAction
    data class OnDetailsClicked(val id: Int) : MainMVIAction
    data class OnTvShowClicked(val id: Int) : MainMVIAction
    data class OnAllVideoClicked(
        val screenType: AllVideosState.ScreenType,
        val title: String,
        val genre: String? = null,
        val isSerial: Boolean? = null
    ) : MainMVIAction

    data object OnSearchClicked : MainMVIAction
    data object AppInfo : MainMVIAction
    data object UpdateClicked : MainMVIAction
    data object ProfileClicked : MainMVIAction
    data object DecideClicked : MainMVIAction
    data class OpenContinue(val entry: WatchEntry) : MainMVIAction
    data class HideContinue(val entry: WatchEntry) : MainMVIAction
    data object ClearLastFocusedVideo : MainMVIAction
}